<script>
import { mapGetters } from 'vuex';
import '../directives';
import { setTimeout } from 'timers';

export default {
    name: 'QuestionListHeader',
    props: {
        isDisabled: Boolean,
    },
    data: () => {
        return {
            isInputMode: false,
            searchQuery: '',
        }
    },
    methods: {
        getCategorySlug(categoryId) {
            const category = this.categories.find(item => item.id === categoryId);
            return category ? category.slug : null;
        },
        setCategoryFilter(categoryId) {
            this.$store.dispatch('updateQuestionCategoryFilter', categoryId);
        },
        isActiveCategory(categoryId) {
            if (this.filterCategories.length === 0
                || this.filterCategories.indexOf(categoryId) > -1)
                return true;
            else
                return false;
        },
        setSearchInputMode(value) {
            this.isInputMode = value;
        },
        onSearchBlur(onSearchBlur) {
            if (!onSearchBlur)
                this.setSearchInputMode(false);
        },
        onSearchChange(searchQuery) {
            this.$store.dispatch('searchQuestions', searchQuery);
        },
        onSearchReset(event) {
            this.setSearchInputMode(false);
            this.searchQuery = '';
            this.$store.dispatch('searchQuestionsReset');
            if (event)
                setTimeout(() => { event.target.blur(); }, 10);
        },
    },
    computed: {
        ...mapGetters({
            categories: 'getAllQuestionCategories',
            filterCategories: 'getQuestionCategoryFilter',
            isSearchLoading: 'getSearchIsLoading',
        }),
    },
    beforeDestroy() {
        this.onSearchReset();
    },
};
</script>

<template>
    <div class="question-list-header">
        <div class="question-search" v-bind:class="{'question-search--input-mode': isInputMode}">
            <input 
                type="text" 
                class="question-search__input" 
                v-bind:placeholder="$t('questionSearch.placeholder')" 
                v-on:focus="setSearchInputMode(true)"
                v-on:change="onSearchChange(searchQuery)"
                v-on:keyup.esc="onSearchReset($event)" 
                v-debounce="500" v-model.lazy="searchQuery">
            <button v-on:click="onSearchReset" class="question-search__reset" v-if="isInputMode"></button>
        </div>
        
        <ul class="category-filter" v-if="!isDisabled && !isInputMode">
            <li 
                class="category-filter__item" 
                v-for="(category, index) in categories" 
                v-bind:key="index" 
                v-bind:class="{'category-filter__item--hi': isActiveCategory(category.id)}" 
                v-on:click="setCategoryFilter(category.id)" 
                v-if="category.count > 0">
                    <span class="category-filter__checkbox">
                        <span class="category-filter__indicator" v-bind:class="['category--' + getCategorySlug(category.id)]"></span>
                    </span>
                    <span class="category-filter__label">{{ category.name }}</span>
            </li>
        </ul>
    </div>
</template>

<style lang="scss" scoped>
.question-list-header {
    position: relative;
    border-top: 0.1rem solid rgba($color-primary, 0.16);
    padding: 1.4rem 0 8.2rem;
    height: 2.1rem;

    @include breakpoint('sm-down') {
        padding-top: 0.64rem;
    }
}

.category-filter {
    display: flex;
    margin: 0 -0.8rem;
    padding: 0;

    @include breakpoint('sm-down') {
        padding-top: 0.8rem;
    }
}
.category-filter__item {
    list-style: none;
    margin: 0 0.8rem;
    cursor: pointer;
    font-size: 1.6rem;
}
.category-filter__checkbox {
    display: inline-block;
    margin: 0 0.8rem 0 0;
    width: 1.6rem; height: 1.6rem;
    border-radius: 50%;
    border: 0.1rem solid rgba($color-primary, .4);
    line-height: 1;
    text-align: center;
}
.category-filter__indicator {
    display: inline-block;
    width: 1rem; height: 1rem;
    border-radius: 50%;
    opacity: 0;
}
.category-filter__item--hi .category-filter__indicator {
    opacity: 1;
}

.question-search {
    position: absolute;
    top: 1.1rem; right: 0;
    width: 22.4rem;
    transition: width 140ms cubic-bezier(0.215, 0.61, 0.355, 1);

    @include breakpoint('sm-down') {
        position: relative;
        top: 0;
        width: 100%;
        padding-bottom: 0.64rem;
        border-bottom: 0.1rem solid rgba($color-primary, 0.16);
    }
}
.question-search--input-mode {
    width: 100%;
}
.question-search__input {
    font-family: $font-family;
    width: 100%;
    box-sizing: border-box;
    margin: 0;
    padding: 0 2.24rem 0 0;
    font-size: 1.6rem;
    text-align: right;
    color: $color-primary;
    letter-spacing: 0.057rem;
    border: none;
    background: center right url(~@/assets/images/ico-search.svg) no-repeat;

    @include breakpoint('sm-down') {
        text-align: left;
    }
}
.question-search__input:focus {
    outline: none;
}
.question-search__input::placeholder {
    opacity: .6;
}
.question-search--input-mode .question-search__input {
    font-size: 2rem;
    text-align: left;

    @include breakpoint('sm-down') {
        font-size: 1.6rem;
    }
}
.question-search__reset {
    position: absolute;
    top: -0.5rem; right: -0.6rem;
    width: 3.2rem; height: 3.2rem;
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
    background: center $color-light url(~@/assets/images/ico-search-close.svg) no-repeat;
    cursor: pointer;
}
</style>
